import { useState, useEffect } from 'react';

function ImageOptionsEditor({properties, updateImage, frameWidth, frameHeight})
{
    const [selectedPosition, setSelectedPosition] = useState(properties.position);

    useEffect(() => {
        setSelectedPosition(properties.position);
    }, [properties]);

    return (
        <>
            <h2 className="titre-options">Options de l’image/motif</h2>

            <div className="img-motif flexNoWrap flexMiddle flexJustify">

                <div className="joystick-img-container flexColumn flexMiddle">
                    <button
                        className="joystick up-joystick keep-click"
                        onClick={() => {
                            updateImage({
                                ...properties,
                                y: properties.y - 4
                            })
                        }}
                    ></button>
                    <div className="col-1 flexJustify flexMiddle">
                        <button
                            className="joystick left-joystick keep-click"
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x: properties.x - 4
                                })
                            }}
                        ></button>
                        <img src="images/icons/picture.svg" className="img-joystick" alt="Image personnalisation tampon" />
                        <button
                            className="joystick right-joystick keep-click"
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x: properties.x + 4
                                })
                            }}
                        ></button>
                    </div>
                    <button
                        className="joystick down-joystick keep-click"
                        onClick={() => {
                            updateImage({
                                ...properties,
                                y: properties.y + 4
                            })
                        }}
                    ></button>
                </div>

                <div className="position-img-container flexColumn flexMiddle">

                    <div className="col-1 flexJustify flexMiddle">
                        <button
                            id="position-1"
                            className={"position up-left-position" + (selectedPosition === 1 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:4,
                                    y:4,
                                    position: 1
                                });
                                setSelectedPosition(1);
                            }}
                        ></button>
                        <button
                            id="position-2"
                            className={"position up-middle-position" + (selectedPosition === 2 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x: (frameWidth / 2) - (properties.width / 2) + 4,
                                    y:4,
                                    position: 2
                                });
                                setSelectedPosition(2);
                            }}
                        ></button>
                        <button
                            id="position-3"
                            className={"position up-right-position" + (selectedPosition === 3 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:frameWidth - properties.width - 4,
                                    y:4,
                                    position: 3
                                });
                                setSelectedPosition(3);
                            }}
                        ></button>
                    </div>

                    <div className="col-2 flexJustify flexMiddle">
                        <button
                            id="position-4"
                            className={"position middle-left-position" + (selectedPosition === 4 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:4,
                                    y:(frameHeight / 2) - (properties.height / 2) + 4,
                                    position: 4
                                });
                                setSelectedPosition(4);
                            }}
                        ></button>
                        <button
                            id="position-5"
                            className={"position middle-middle-position" + (selectedPosition === 5 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:(frameWidth / 2) - (properties.width / 2) + 4,
                                    y:(frameHeight / 2) - (properties.height / 2) + 4,
                                    position: 5
                                });
                                setSelectedPosition(5);
                            }}
                        ></button>
                        <button
                            id="position-6"
                            className={"position middle-right-position" + (selectedPosition === 6 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:frameWidth - properties.width - 4,
                                    y:(frameHeight / 2) - (properties.height / 2) + 4,
                                    position: 6
                                });
                                setSelectedPosition(6);
                            }}

                        ></button>
                    </div>

                    <div className="col-3 flexJustify flexMiddle">
                        <button
                            id="position-7"
                            className={"position down-left-position" + (selectedPosition === 7 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:4,
                                    y:frameHeight- properties.height - 4,
                                    position: 7
                                });
                                setSelectedPosition(7);
                            }}
                        ></button>
                        <button
                            id="position-8"
                            className={"position down-middle-position" + (selectedPosition === 8 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:(frameWidth / 2) - (properties.width / 2) + 4,
                                    y:frameHeight- properties.height - 4,
                                    position: 8
                                });
                                setSelectedPosition(8);
                            }}
                        ></button>
                        <button
                            id="position-9"
                            className={"position down-right-position" + (selectedPosition === 9 ? ' position-active' : '')}
                            onClick={() => {
                                updateImage({
                                    ...properties,
                                    x:frameWidth - properties.width - 4,
                                    y:frameHeight- properties.height - 4,
                                    position: 9
                                });
                                setSelectedPosition(9);
                            }}
                        ></button>
                    </div>

                </div>

                <div className="taille-img-container flexColumn flexMiddle">
                    <button
                        className="taille plus-taille keep-click"
                        onClick={() => {
                            let ratio = properties.width / properties.height;

                            updateImage({
                                x: properties.x - 2,
                                y: properties.y - 2,
                                width: properties.width + 4,
                                height: ratio * properties.width
                            })
                        }}
                    >+</button>
                    <img src="images/icons/picture.svg" className="img-taille" alt="Image personnalisation tampon" />
                    <button
                        className="taille moins-taille keep-click"
                        onClick={() => {
                            let ratio = properties.width / properties.height;

                            updateImage({
                                x: properties.x + 2,
                                y: properties.y + 2,
                                width: properties.width - 4,
                                height: ratio * properties.width
                            })
                        }}
                    >-</button>
                </div>
            </div>
        </>
    )
}

export default ImageOptionsEditor;